import { NgModule } from '@angular/core';
import { MultipleTemplateDirective } from './directive/multiple-template.directive';
import { MultipleTemplateComponent } from './component/multiple-template.component';

@NgModule({
  declarations: [MultipleTemplateDirective, MultipleTemplateComponent],
  exports: [MultipleTemplateDirective, MultipleTemplateComponent],
})
export class ThemeModule {}
